<template>
  <v-select
    v-model="selected"
    :items="localOrganizations"
    :label="localLabel"
    item-text="display"
    item-value="id"
    hide-no-data
    :required="required"
    hide-selected
    :menu-props="{
      closeOnContentClick: true
    }"
    :error-messages="errors"
  >
    <template slot="item" slot-scope="{ item }">
      <template v-if="item.type === 'header'">
        <v-list-item-content v-text="item.display"></v-list-item-content>
      </template>
      <template>
        <v-list-item-avatar size="32px">
          <img v-if="item.avatar" :src="item.avatar" />
          <v-icon v-else small>{{ $vuetify.icons.values.organization }}</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title v-html="item.display"></v-list-item-title>
        </v-list-item-content>
      </template>
    </template>
  </v-select>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { NAMESPACE } from '../store'
export default {
  name: 'OrganizationField',
  props: {
    updateSelection: Function,
    provided: Array,
    selection: [Number, String],
    errors: Array,
    required: Boolean,
    multiple: { type: Boolean, default: true },
    label: { type: String, default: null }
  },
  methods: {
    ...mapActions(NAMESPACE, ['listOrganizations'])
  },
  computed: {
    ...mapState(NAMESPACE, ['organizations']),
    selected: {
      get() {
        return this.selection
      },
      set(value) {
        this.updateSelection(value)
      }
    },
    localOrganizations() {
      return this.provided || this.organizations
    },
    localLabel() {
      return this.label || this.$t('labels.organization')
    }
  },
  created() {
    let getOrganizations = !this.provided && this.organizations.length === 0
    if (getOrganizations) {
      this.listOrganizations({}).catch(() => {})
    }
  }
}
</script>
